const $ = require('jquery');
import run from '../../utilities/run';
import {quickFileUploader} from "../../components/QuickFileUploader/QuickFileUploader";
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import {SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT} from "../../constants";
require("../stubs/workOrderDetailsRetailerStub/workOrderDetails.less");

// Live form from jsp
run("#work-order-details", ()=>{
  const el = $("#work-order-details");
  workOrderDetails(el);
});

function workOrderDetails(el){

  //data from JSP
  const workOrder = JSON.parse(JSON.stringify(el.data("work-order")));
  const cancelWOUrl = el.data("cancel-wo-url");
  const addQuoteUrl = el.data("add-quote-url");
  const approveQuoteUrl = el.data("approve-quote-url");
  const rejectQuoteUrl = el.data("reject-quote-url");
  const rejectAndCancelQuoteUrl = el.data("reject-and-cancel-wo-url");
  const postWorkOrderCommentUrl = el.data("post-work-order-comment-url");
  const updateWOStatusUrl = el.data("update-wo-status-url");
  const statusAssigned = el.data("status-assigned");
  const statusInProcess = el.data("status-in-process");
  const statusCompleted = el.data("status-completed");

  //Find ids
  const cancelWorkOrderBtn = el.find(".wo-cancel-work-order-btn");
  const approveQuoteBtn = el.find(".wo-approve-quote-btn");
  const rejectQuoteBtn = el.find(".wo-reject-quote-btn");
  const addQuoteBtn = el.find(".wo-add-quote-btn");
  const updateQuoteBtn = el.find(".wo-update-quote-btn");
  const assignToFacilityBtn = el.find(".wo-assign-to-facility-btn");
  const markAsInProcessBtn = el.find(".wo-mark-as-in-process-btn");
  const markAsCompleteBtn = el.find(".wo-mark-as-complete-btn");
  
  const cancelWorkOrderModal = $("#cancel-work-order-modal");
  const cancelWorkOrder = cancelWorkOrderModal.find(".cancel-work-order");

  const approveQuoteModal = $("#approve-quote-modal");
  const approveQuote = approveQuoteModal.find(".approve-quote");

  const rejectQuoteModal = $("#reject-quote-modal");
  const rejectQuote = rejectQuoteModal.find(".reject-quote");
  const rejectAndCancelQuote = rejectQuoteModal.find(".rejectandcancel-quote");

  const addQuoteModal = $("#add-quote-modal");
  const addQuote = addQuoteModal.find(".add-quote");
  const cancelQuoteBtn = addQuoteModal.find(".cancel-quote");

  const cancelQuoteModal = $("#cancel-quote-modal");
  const cancelQuote = cancelQuoteModal.find(".no-btn");
  
  const postCommentBtn = el.find(".post-comment");
  const postCommentText = el.find("#postComment");

  const modalOpts = {backdrop:'static', show: false};
  cancelWorkOrderModal.modal(modalOpts);
  approveQuoteModal.modal(modalOpts);
  rejectQuoteModal.modal(modalOpts);
  addQuoteModal.modal(modalOpts);
  cancelQuoteModal.modal(modalOpts);

  const quoteUploaderEl = addQuoteModal.find(".quote-uploader");
  quickFileUploader(quoteUploaderEl);

  $('.quote-uploader input').on("change", function(){
    const validator = $(".wo-add-quote-form").validate({
      errorPlacement: function(error, element) {
        let appendClosest = $(element).data('error-placement-append-closest');
        if (appendClosest) {
        $(element).closest(appendClosest).append(error);
        } else {
        error.insertAfter(element);
        }
      }
    });    
    validator.elements().valid();
  });
  
  $(cancelWorkOrderBtn).on("click", function(e){
    e.preventDefault();
    cancelWorkOrderModal.modal("show");
  });
  
  $(cancelWorkOrder).on("click", function(){
    const validator = $(".wo-cancel-form").validate({
      errorPlacement: function(error, element) {
        let appendClosest = $(element).data('error-placement-append-closest');
        if (appendClosest) {
        $(element).closest(appendClosest).append(error);
        } else {
        error.insertAfter(element);
        }
      }
    });
    if(validator.elements().valid()) {
      const submitModalFlow = new SubmitModalFlow();
      submitModalFlow.init();
      cancelWorkOrderModal.modal('hide');
      submitModalFlow.showLoadingModal();
      $.ajax({
        url: cancelWOUrl,
        type: 'POST',
        dataType: 'JSON',
        data: {
          worId: workOrder.worId,
          comment: $('#cancelWOReason').val()
        },
        success: function() {
          submitModalFlow.showSuccessModal();
          setTimeout(function() {
            location.reload();
          }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
        },
        error: function() {
          submitModalFlow.hideAllModals();
        }
      });
    }
  });

  $(addQuote).on("click", function(){
    const validator = $(".wo-add-quote-form").validate({
      errorPlacement: function(error, element) {
        let appendClosest = $(element).data('error-placement-append-closest');
        if (appendClosest) {
        $(element).closest(appendClosest).append(error);
        } else {
        error.insertAfter(element);
        }
      }
    });
    if(validator.elements().valid()) {
      const submitModalFlow = new SubmitModalFlow();
      submitModalFlow.init();
      addQuoteModal.modal('hide');
      submitModalFlow.showLoadingModal();
      let formData = new FormData();
      formData.append('worId', workOrder.worId);
      formData.append('worCost', $('#worCost').val());
      formData.append('worEstiDuration', $('#worEstiDuration').val());
      formData.append('quoteFile', $('#quoteFile')[0].files[0]);
      $.ajax({
        url: addQuoteUrl,
        type: 'POST',
        dataType: 'JSON',
        data: formData,
        processData: false,  // tell jQuery not to process the data
        contentType: false,   // tell jQuery not to set contentType
        success: function(){
          submitModalFlow.showSuccessModal();
          setTimeout(function() {
            location.reload();
          }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
        },
        error: function() {
          submitModalFlow.hideAllModals();
        }
      });
    }
  });
  
  $(cancelQuote).on("click", function(){
    addQuoteModal.modal("show");
  });  
  
  $(approveQuote).on("click", function(){
    const submitModalFlow = new SubmitModalFlow();
    submitModalFlow.init();
    approveQuoteModal.modal('hide');
    submitModalFlow.showLoadingModal();
    $.ajax({
      url: approveQuoteUrl,
      type: 'POST',
      dataType: 'JSON',
      data: {
        worId: workOrder.worId
      },
      success: function(){
        submitModalFlow.showSuccessModal();
        setTimeout(function() {
          location.reload();
        }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
      },
      error: function() {
        submitModalFlow.hideAllModals();
      }
    });
  });

  $(rejectQuote).on("click", function(){
    const validator = $(".wo-reject-quote-form").validate({
      errorPlacement: function(error, element) {
        let appendClosest = $(element).data('error-placement-append-closest');
        if (appendClosest) {
        $(element).closest(appendClosest).append(error);
        } else {
        error.insertAfter(element);
        }
      }
    });
    if(validator.elements().valid()) {
      const submitModalFlow = new SubmitModalFlow();
      submitModalFlow.init();
      rejectQuoteModal.modal('hide');
      submitModalFlow.showLoadingModal();
      $.ajax({
        url: rejectQuoteUrl,
        type: 'POST',
        dataType: 'JSON',
        data: {
          worId: workOrder.worId,
          comment: $('#rejectQuoteComment').val()
        },
        success: function(){
          submitModalFlow.showSuccessModal();
          setTimeout(function() {
            location.reload();
          }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
        },
        error: function() {
          submitModalFlow.hideAllModals();
        }
      });
    }
  });

  $(rejectAndCancelQuote).on("click", function(){
    const validator = $(".wo-reject-quote-form").validate({
      errorPlacement: function(error, element) {
        let appendClosest = $(element).data('error-placement-append-closest');
        if (appendClosest) {
        $(element).closest(appendClosest).append(error);
        } else {
        error.insertAfter(element);
        }
      }
    });
    if(validator.elements().valid()) {
      const submitModalFlow = new SubmitModalFlow();
      submitModalFlow.init();
      rejectQuoteModal.modal('hide');
      submitModalFlow.showLoadingModal();
      $.ajax({
        url: rejectAndCancelQuoteUrl,
        type: 'POST',
        dataType: 'JSON',
        data: {
          worId: workOrder.worId,
          comment: $('#rejectQuoteComment').val()
        },
        success: function(){
          submitModalFlow.showSuccessModal();
          setTimeout(function() {
            location.reload();
          }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
        },
        error: function() {
          submitModalFlow.hideAllModals();
        }
      });
    }
  });
  
  function updateWOStatus(status){
    $.ajax({
      url: updateWOStatusUrl,
      type: 'POST',
      dataType: 'JSON',
      data: {
        worId: workOrder.worId,
        worStatus: status
      },
      success: function(){
        location.reload();
      }
    });
  }
  
  approveQuoteBtn.on("click", function(e){
    e.preventDefault();
    approveQuoteModal.modal("show");
  });

  rejectQuoteBtn.on("click", function(e){
    e.preventDefault();
    rejectQuoteModal.modal("show");
  });

  addQuoteBtn.on("click", function(e){
    e.preventDefault();
    addQuoteModal.modal("show");
  });
  
  cancelQuoteBtn.on("click", function(e){
    e.preventDefault();
    addQuoteModal.modal("hide");
    cancelQuoteModal.modal("show");
  });

  updateQuoteBtn.on("click", function(e){
    e.preventDefault();
    addQuoteModal.modal("show");
  });
  
  postCommentBtn.on("click", function(e){
    e.preventDefault();
    if ($.trim(postCommentText.val())){
      submitUserComment();
    }
  });

  function submitUserComment(){
    $.ajax({
      url: postWorkOrderCommentUrl,
      type: 'POST',
      dataType: 'JSON',
      data: {
        worId: workOrder.worId,
        postComment: postCommentText.val()
      },
      success: function(){
        location.reload();
      }
    });
  }

  assignToFacilityBtn.on("click", function(e){
    e.preventDefault();
    updateWOStatus(statusAssigned);
  });

  markAsInProcessBtn.on("click", function(e){
    e.preventDefault();
    updateWOStatus(statusInProcess);
  });

  markAsCompleteBtn.on("click", function(e){
    e.preventDefault();
    updateWOStatus(statusCompleted);
  });  
}



// WEBPACK FOOTER //
// ./src/pages/workorder/workOrder-detail.js